import styled from "styled-components";
import { NavLink } from "react-router-dom";
import Typography from "components/core/typography";
import Icon from "./core/icon";

const BottomMenu = () => {
  return (
    <BottomMenuWrapper>
      <NavLinkWrapper>
        <NavLinkItem to="/">
          <Icon name="insights" />
          <Typography variant="small" textAlign="center">
            Insights
          </Typography>
        </NavLinkItem>
        <NavLinkItem to="/transactions" className="transactions">
          <Icon name="transactions" />
          <Typography variant="small" textAlign="center">
            Transactions
          </Typography>
        </NavLinkItem>
        <NavLinkItem to="/statements">
          <Icon name="file-excel" />
          <Typography variant="small" textAlign="center">
            Statements
          </Typography>
        </NavLinkItem>
        <NavLinkItem to="/settings">
          <Icon name="cog" />
          <Typography variant="small" textAlign="center">
            Settings
          </Typography>
        </NavLinkItem>
      </NavLinkWrapper>
    </BottomMenuWrapper>
  );
};

const BottomMenuWrapper = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 61px;
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.15) 0px -2px 11px 2px;
  @media (min-width: 768px) {
    position: fixed;
    bottom: initial;
    top: 0;
    left: calc(50% - 240px);
    max-width: 600px;
    background: transparent;
    box-shadow: none;
    z-index: 99;
  }
`;

const NavLinkWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const NavLinkItem = styled(NavLink)`
  text-align: center;
  border-top: 4px solid transparent;
  width: 25%;
  padding: 8px 0;
  color: #222;
  i {
    font-size: 20px;
    line-height: 20px;
    display: block;
    margin-bottom: 6px;
  }
  &.transactions {
    i {
      font-size: 28px;
    }
  }
  &.active {
    border-top-color: #006bff;
    i,
    small {
      color: #006bff;
    }
  }
  p {
    font-size: 14px;
    line-height: 14px;
  }
  @media (min-width: 768px) {
    display: flex;
    font-size: 18px;
    column-gap: 8px;
    align-items: center;
    padding: 8px 0;
    margin: 13px 0;
    border-top: 0;
    justify-content: center;
    border-radius: 6px;
    color: #fff;
    small {
      color: #fff;
    }
    i {
      margin-bottom: 0;
      opacity: 0.5;
    }
    &.active {
      border-top: none;
      color: #006bff;
      background: #fff;
      small {
        color: #006bff;
      }
      i {
        opacity: 0.75;
      }
    }
  }
`;

export default BottomMenu;
